import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
const links = [{
  label: 'Thuisbatterij',
  to: '/thuisbatterij'
}, {
  label: 'Huisscan',
  to: '/scan'
}, {
  label: 'De app',
  to: '/#app'
}, {
  label: 'Werkwijze',
  to: '/#werkwijze'
}, {
  label: 'Over ons',
  to: '/over-ons'
}, {
  label: 'Contact',
  to: '/contact'
}];
interface HeaderProps {
  overlay?: boolean;
}
export function Header({
  overlay = false
}: HeaderProps) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    if (!overlay) return;
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, [overlay]);
  const transparent = overlay && !scrolled && !open;
  return <header className={`sticky top-0 z-50 transition-colors duration-200 ${transparent ? 'bg-transparent' : 'border-b border-line/70 bg-canvas/95 backdrop-blur-md'}`} data-id="element-338" data-mp="6uvojh6exfwr">
      <div className="mx-auto flex h-[76px] max-w-[1440px] items-center justify-between gap-6 px-4 sm:px-6 lg:px-10" data-id="element-339" data-mp="gmje1cjesmvl">
        <Link to="/" aria-label="Stroomkluis home" className="rounded-md focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-volt" data-id="element-340" data-mp="lk1ioqqe8fxs">
          <Logo tone={transparent ? 'light' : 'dark'} data-id="element-341" data-mp="3p22zvqhr330m" />
        </Link>

        <nav aria-label="Hoofdmenu" className="hidden items-center gap-0.5 lg:flex" data-id="element-342" data-mp="3tzv3vivo6fl6">
          {links.map(l => <NavLink key={l.to} to={l.to} end className={({
          isActive
        }) => `whitespace-nowrap rounded-full px-3.5 py-2 text-[15px] font-medium transition-colors duration-150 ${transparent ? 'text-canvas/85 hover:bg-canvas/10 hover:text-canvas' : isActive && !l.to.includes('#') ? 'bg-canvas-deep text-ink' : 'text-ink-soft hover:bg-canvas-deep hover:text-ink'}`} data-id="element-343" data-mp="1xn4tc5m93te">
              {l.label}
            </NavLink>)}
        </nav>

        <div className="flex items-center gap-2" data-id="element-344" data-mp="3ec5irmi0200j">
          <a href="tel:0850000000" className={`hidden items-center gap-2 whitespace-nowrap px-3 py-2 text-[15px] font-medium transition-colors duration-150 xl:inline-flex ${transparent ? 'text-canvas/85 hover:text-canvas' : 'text-ink-soft hover:text-ink'}`} data-id="element-345" data-mp="2qp78j6kh3ob2">
            <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-346" data-mp="2vm62np44zv99" />
            085 – 000 00 00
          </a>
          <Link to="/scan" className="whitespace-nowrap rounded-full bg-volt px-5 py-2.5 text-[15px] font-semibold text-ink transition-colors duration-150 hover:bg-volt-deep" data-id="element-347" data-mp="27vtk7kb9mg4f">
            Gratis huisscan
          </Link>
          <button type="button" className={`ml-1 inline-flex h-10 w-10 items-center justify-center rounded-full lg:hidden ${transparent ? 'text-canvas hover:bg-canvas/10' : 'text-ink hover:bg-canvas-deep'}`} aria-label={open ? 'Menu sluiten' : 'Menu openen'} aria-expanded={open} onClick={() => setOpen(o => !o)} data-id="element-348" data-mp="n7r389iil2n7">
            {open ? <XIcon className="h-5 w-5" data-id="element-349" data-mp="165toqebushg9" /> : <MenuIcon className="h-5 w-5" data-id="element-350" data-mp="1640q9mbe93jc" />}
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-351" data-mp="s8omyqj6a4qt">
        {open && <motion.nav aria-label="Mobiel menu" initial={{
        opacity: 0,
        y: -6
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -6
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} className="border-t border-line bg-canvas px-4 pb-4 pt-2 lg:hidden" data-id="element-352" data-mp="x4vu2mnb1mac">
            {links.map(l => <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-3 text-base font-medium text-ink hover:bg-canvas-deep" data-id="element-353" data-mp="3sf2set8d6wpk">
                {l.label}
              </Link>)}
          </motion.nav>}
      </AnimatePresence>
    </header>;
}